import { Chip } from '@mui/material';
import { Rating } from '../../shared/types.js';
import { colors } from '../styles/theme.js';

interface Props {
  rating: Rating;
  label?: string;
  size?: 'small' | 'medium';
}

const ratingConfig: Record<Rating, { bg: string; label: string }> = {
  [Rating.G]: { bg: colors.scoreGreen, label: 'Grün' },
  [Rating.Y]: { bg: colors.scoreYellow, label: 'Gelb' },
  [Rating.R]: { bg: colors.scoreRed, label: 'Rot' },
};

export default function RatingChip({ rating, label, size = 'small' }: Props) {
  const config = ratingConfig[rating];
  return (
    <Chip
      label={label ?? config.label}
      size={size}
      sx={{
        bgcolor: config.bg,
        color: '#fff',
        fontWeight: 600,
        minWidth: 56,
      }}
    />
  );
}
